import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { 
  Box, 
  Typography, 
  Button,
  Paper,
  Alert,
} from '@mui/material';
import { ArrowBack, Assignment } from '@mui/icons-material';

const SurveyDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <Button
          startIcon={<ArrowBack />}
          onClick={() => navigate('/surveys')}
          variant="outlined"
        >
          Back to Surveys
        </Button>
        <Box>
          <Typography variant="h4" gutterBottom>
            Survey Details
          </Typography>
          <Typography variant="subtitle1" color="text.secondary">
            Survey ID: {id}
          </Typography>
        </Box>
      </Box>

      <Paper sx={{ p: 3 }}>
        <Alert severity="info" sx={{ mb: 2 }}>
          <Typography variant="h6" gutterBottom>
            🚧 Page Under Development
          </Typography>
          This page will include:
          <ul>
            <li>Survey form with data collection fields</li>
            <li>Photo capture and measurement tools</li>
            <li>Heat loss calculations for heat pumps</li>
            <li>Roof assessment for solar installations</li>
            <li>Electrical system evaluation</li>
            <li>Survey report generation and approval</li>
            <li>Integration with project workflow</li>
          </ul>
        </Alert>
        
        <Box sx={{ textAlign: 'center', py: 4 }}>
          <Assignment sx={{ fontSize: 80, color: 'text.secondary', mb: 2 }} />
          <Typography variant="h6" color="text.secondary">
            Survey detail view coming soon
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Survey ID: {id}
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};

export default SurveyDetailPage;
